<template>
    <div>
        <loading-plugin :active='isLoading'/>

        <ul id="event-list" class="list-unstyled mb-4">
            <event-search v-model="query" @input="search"></event-search>
            <li v-for="event in events" :status="event._Status.string" class="bg-white py-3 px-4 mb-2 border rounded" :key="`event_${event.EventID}`" >
                <div v-if="event._Status.code !== 0">
                    <span class="badge status-badge fw-500" :status="event._Status.string">{{ event._Status.string }}</span>
                </div>

                <div>
                    <a class="event-name fs-5 fw-600" href="javascript:void(0)" @click="$router.push(`/event/${ event.EventID }`)">{{ event.EventName }}</a>
                </div>
                <div>
                    <a class="event-location text-decoration-none" :href="`/location/${event._LocationDetails.LocationGUID}`" target="_blank">
                        <i class="fas fa-map-marker-alt"></i>&nbsp;{{ event._LocationDetails.Name }}
                    </a>
                </div>
                <!-- <div class="container mt-3"> -->
                    <div class="d-flex flex-wrap justify-content-start mt-3" style="gap:1ex 0.5em;">
                        <div class="">
                            <div class="event-detail">
                                <i class="far fa-calendar-alt me-2"></i><b>{{ event.StartString }}</b>
                            </div>
                        </div>
                        <div class="">
                            <div class="event-detail col-6">
                                <i class="fas fa-users me-2"></i>Available seats:<span class="ms-2 fw-500">{{ event.RemainingSeats }}</span>
                            </div>
                        </div>

                        <div class="">
                            <div class="event-detail me-2">
                                Event Fee:&nbsp;
                                <span v-if="event.EventFee == '*'" style="color:DarkRed"><i class="fas fa-star-of-life"></i></span>
                                <span v-else-if="event.EventFee == 'Free'" style="color:DarkGreen;" class="fw-500">Free</span>
                                <span v-else class="fw-500">${{ event.EventFee }}</span>
                            </div>
                        </div>

                        <div class=""  v-if="event.EventFeeMemberRaw && event.Member" >
                            <div class="event-detail event-detail-member">
                                <span class="me-2">Member Fee:</span>                                
                                <span v-if="event.EventFeeMember == '*'" style="color:DarkRed"><i class="fas fa-star-of-life"></i></span>
                                <span v-else-if="event.EventFeeMember == 'Free'" style="color:DarkGreen;" class="fw-500">Free</span>
                                <span v-else class="fw-500">${{ event.EventFeeMember }}</span>
                            </div>
                        </div>

                        <div class="" v-if="event.ContactHours">
                            <div class="event-detail">
                                <i class="fas fa-certificate me-2"></i>Contact hours:<span class="ms-2 fw-500">{{event.ContactHours }}</span>
                            </div>
                        </div>

                        <div class="" v-if="event.GradCredit">
                            <div class="event-detail">
                                <i class="fas fa-graduation-cap me-2"></i>Grad credit:<span class="ms-2 fw-500">{{ event.GradCredit }}</span>
                            </div>
                        </div>
                    </div>
                <!-- </div> -->

            </li>
        </ul>
    </div>
</template>

<script>
import LoadingPlugin from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/vue-loading.css';
import Datepicker from 'vuejs-datepicker';
import EventSearch from './components/EventSearch.vue';

export default {
    components: { LoadingPlugin, Datepicker, EventSearch },

    data() {
        return {
            isLoading: false,
            events: [],

            query: {
                start: null,
                end: null,
                inactive: false,
                search: '',
            },
        }
    },

    mounted() {
        this.getEvents();
    },

    methods: {
        getEvents: function() {
            this.isLoading = true;
            
            let query = [];
            
            for (let [key, value] of Object.entries(this.query)) {
                if (value) {
                    query.push(`${key}=${value}`);
                }
            }

            for (let [key, value] of Object.entries(this.$route.query)) {
                if (!Object.hasOwn(this.query, key)) {
                    if (value) {
                        query.push(`${key}=${value}`);
                    } else {
                        query.push(key);
                    }
                }
            }

            query = query.join('&');
            axios
                .get(`/api/events?${query}`)
                .then((response) => {
                    this.events = response.data.data;
                })
                .catch((error) => {
                    console.error(error);
                })
                .finally(() => {
                    this.isLoading = false;
                });
        },

        search: function() {
            this.getEvents();
        },
    }

}
</script>

<style scoped>
    #event-list a {
        color: #2f2f2f;
    }

    #event-list li:not([status="ACTIVE"]) {
        background: #f6f6f9 !important;
    }

    .status-badge {
        background: #343a40;
    }
    .status-badge[status="CLOSED"] {
        background: #0d6efd;
    }
    .status-badge[status="INACTIVE"] {
        background: #dc3545;
    }
    .status-badge[status="CANCELLED"] {
        background: #fd7e14;
    }
    .status-badge[status="FULL"] {
        background: #0dcaf0;
    }
    .status-badge[status="UNKNOWN"] {
        background: #6610f2;
    }

    .event-detail {
        border: 2px solid SkyBlue;
        border-radius: 1em;
        background-color: AliceBlue;
        padding: .25em 1em;
        font-size: smaller;
        font-weight: 300;
        white-space: nowrap;
        display: inline;
    }

    .event-detail-member {
        border: 2px solid LightGreen;
        background-color: HoneyDew;
    }

    .search-container {
        right: 0;
        top: 100%;
        box-shadow: 0px 2px 3px rgba(0,0,0,.3);
    }
    
    .search-container input[type="search"] {
        border-top-right-radius: 0 !important;
        border-bottom-right-radius: 0 !important;
    }
    
    .search-container .input-group button {
        border-top-left-radius: 0 !important;
        border-bottom-left-radius: 0 !important;
    }
    
    #search-menu .input-group-prepend,
    #search-menu .input-group-append {
        display: flex;
    }
    
    #search-menu .input-group-prepend .input-group-text {
        border-top-right-radius: 0;
        border-bottom-right-radius: 0;
    }
    
    #search-menu .input-group-append .input-group-text {
        border-top-left-radius: 0;
        border-bottom-left-radius: 0;
    }
</style>
